import { render, staticRenderFns } from "./EventLogs.vue?vue&type=template&id=6d60018a&scoped=true"
import script from "./EventLogs.vue?vue&type=script&lang=js"
export * from "./EventLogs.vue?vue&type=script&lang=js"
import style0 from "./EventLogs.vue?vue&type=style&index=0&id=6d60018a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60018a",
  null
  
)

export default component.exports